import React, { useState } from "react";
import ChapterList from "../chapter_components/ChapterList";
import ChapterDataService from "../../services/ChapterService";
import { useEffect } from "react";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import CustomTextModal from "../micro_components/CustomTextModal";

import ConfirmationModal from "../micro_components/ConfirmationModal";

//THIS IS GOING TO HOLD THE CHAPTER AT THE HIGHEST LEVEL
//GET CHAPTERS
//UPDATE CHAPTERS
//ADD CHAPTER
const BookResources = (props) => {
  const { bookId } = props;
  //chapter that will be passed down
  const [chapters, setChapters] = useState([]);
  //modal state
  const [addChapterModalOn, setAddChapterModal] = useState(false);
  const [newChapterName, setNewChapterName] = useState("");

  const [rerender, setRerender] = useState(false);

  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  //when page is loaded, get chapters form SQL
  useEffect(() => {
    ChapterDataService.getChaptersInBook(bookId)
      .then((response) => {
        setChapters(response.data);
      })
      .catch((e) => console.log("error getting book " + bookId + " " + e));
  }, [bookId]);

  //repeated this because useEffect wont allow function defined outside of it to be used without making it a dependency
  const getChapters = () => {
    ChapterDataService.getChaptersInBook(bookId)
      .then((response) => {
        setChapters(response.data);
      })
      .catch((e) => console.log("error getting book " + bookId + " " + e));
  };

  //add chapter modal function
  const openAddChapterModal = () => {
    setAddChapterModal(true);
  };

  //close chapter add modal
  const closeAddChapterModal = () => {
    setAddChapterModal(false);
  };

  const changeNewChapterName = (event) => {
    setNewChapterName(event.target.value);
  };

  //Call API to add new chapter
  const submitChapterName = () => {
    const newChapter = {
      name: newChapterName,
      book_id: bookId,
      order_index: chapters.length - 1,
    };
    console.log(newChapter);
    //I made this an array because uploadChapters works and is really all we need
    ChapterDataService.addChapter(bookId, newChapter)
      .then((response) => {
        console.log("success! new chapter: " + JSON.stringify(response));
        setAddChapterModal(false);
        ChapterDataService.getChaptersInBook(bookId)
          .then((response) => {
            setChapters(response.data);
          })
          .catch((e) => console.log("error getting book " + bookId + " " + e));
      })
      .catch((e) => console.log("error adding chapter " + e));
  };

  //called from childs, delete chapter from api
  const deleteChapter = (id) => {
    setConfirmationOpen(true);
    setConfirmationLoading(true);
    ChapterDataService.deleteChapter(bookId, id)
      .then(() => {
        console.log("chapter deleted");
        setConfirmationLoading(false);
        getChapters();
      })
      .catch((e) => {
        console.log("error deleting chapter");
      });
  };

  const handleSetChapters = (data) => {
    console.log("setting chapters: ", data);
    setChapters(data);
    setRerender(!rerender);
  };

  const handleConfirmationClose = () => {
    setConfirmationOpen(false);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "50px 0",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0 10px",
            marginRight: "2em",
          }}
        >
          <h1>Chapters</h1>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            boxShadow: "0 0 0.25em 0.2em rgba(0, 0, 0, 0.2)",
            paddingLeft: "10px",
            marginLeft: "2em",
          }}
        >
          <h5>Create New Chapter</h5>
          <IconButton
            aria-label="create"
            style={{ marginLeft: "50px" }}
            onClick={openAddChapterModal}
          >
            <CreateIcon fontSize="large" color="primary" />
          </IconButton>
        </div>
      </div>
      <div>
        <CustomTextModal
          title={"Add New Chapter"}
          isOpen={addChapterModalOn}
          onClose={closeAddChapterModal}
          changeField={changeNewChapterName}
          onSubmit={submitChapterName}
          initial={""}
        />
      </div>
      <ChapterList
        key={chapters}
        initialChapters={chapters}
        deleteChapter={deleteChapter}
        bookId={bookId}
        setChapters={handleSetChapters}
      />
      {confirmationOpen && (
        <ConfirmationModal
          title="Changes Saved!"
          isOpen={confirmationOpen}
          onClose={handleConfirmationClose}
          isLoading={confirmationLoading}
        />
      )}
    </div>
  );
};

export default BookResources;
